import { createStore, ObservableMap } from "@stencil/store";
import { getMachineList } from "../../api/publicApi/machine";
import { getSoftwares, getSoftwareTypes, Software, SoftwareType } from "../../api/publicApi/software";
import { getNotificationTypes, NotificationType } from "../../api/publicApi/notificationType";
import { PublicApiClient } from "../../api/publicApi/PublicApiClient";
import { ProductTechnologyType } from "../../api/productTechnology";
import { AssetManagementApiClient } from "../../api/assetManagementApi/assetManagementApiClient";

export interface ApiStoreState {
    machinesLoading: boolean;
    machines: {
        assetId: string;
        technologyId: ProductTechnologyType;
        assetName: string;
    }[];
    softwaresLoading: boolean;
    softwares: Software[];
    softwareTypes: SoftwareType[];
    notificationTypesLoading: boolean;
    notificationTypes: NotificationType[];
    loading: boolean;
}
export type ApiStore = ObservableMap<ApiStoreState>;

export const createApiStore = () => {
    const store = createStore<ApiStoreState>({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());

    function updateLoading() {
        store.state.loading = store.state.machinesLoading || store.state.softwaresLoading || store.state.notificationTypesLoading;
    }

    return store;
};

export const loadFormDataFromPublicApi = async (apiStore: ApiStore, apiClient: PublicApiClient) => {
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;

    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
};

export const loadFormDataFromAssetManagementApi = async (apiStore: ApiStore, apiClient: AssetManagementApiClient) => {
    apiStore.state.machinesLoading = true;

    getMachineList(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
};
